import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api/compliance/disclosure`;

/**
 * Renders the mandatory SEBI Research Analyst disclosure block at the bottom
 * of any public page / exported artefact. Values come from the backend env
 * so legal can rotate without a code deploy.
 */
export default function SebiDisclosureFooter({ className = '' }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(API).then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  if (!data) return null;
  const {
    legal_entity, cin, sebi_category, sebi_registration_number, sebi_validity,
    registered_address,
    grievance_officer_name, grievance_officer_email, grievance_phone,
    compliance_officer_name, compliance_officer_email,
    scores_url, sebi_odr_url,
    analyst_certification, disclosures, general_disclaimer,
  } = data;

  return (
    <footer className={`border-t border-border/40 bg-background/80 text-[11px] leading-relaxed text-muted-foreground ${className}`}>
      <div className="max-w-6xl mx-auto px-6 py-8 space-y-3">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <p className="font-semibold text-foreground">{legal_entity}</p>
            {cin && <p>CIN: {cin}</p>}
            <p>{sebi_category}{sebi_registration_number ? ` · ${sebi_registration_number}` : ''}</p>
            {sebi_validity && <p>Valid till: {sebi_validity}</p>}
            {registered_address && <p className="mt-1">{registered_address}</p>}
          </div>
          <div>
            {compliance_officer_name && <p>Compliance Officer: <span className="text-foreground">{compliance_officer_name}</span> — {compliance_officer_email}</p>}
            {grievance_officer_name && <p>Grievance Officer: <span className="text-foreground">{grievance_officer_name}</span> — {grievance_officer_email}{grievance_phone ? ` · ${grievance_phone}` : ''}</p>}
            {!grievance_officer_name && grievance_officer_email && <p>Grievance: <a href={`mailto:${grievance_officer_email}`} className="underline">{grievance_officer_email}</a></p>}
            <p>SEBI SCORES: <a href={scores_url} target="_blank" rel="noreferrer" className="underline">{scores_url}</a></p>
            <p>SEBI ODR: <a href={sebi_odr_url} target="_blank" rel="noreferrer" className="underline">{sebi_odr_url}</a></p>
          </div>
        </div>

        <details className="group">
          <summary className="cursor-pointer text-foreground font-semibold">Full disclosure &amp; disclaimer</summary>
          <div className="pt-2 space-y-2">
            <p>{analyst_certification}</p>
            {disclosures?.positions && <p>{disclosures.positions}</p>}
            {disclosures?.conflicts && <p>{disclosures.conflicts}</p>}
            <p>{general_disclaimer}</p>
          </div>
        </details>

        <p className="text-[10px] text-muted-foreground/70 pt-2 border-t border-border/20">
          © {new Date().getFullYear()} {legal_entity}. All rights reserved.
          &nbsp;·&nbsp;<a href="/terms" className="underline">Terms</a>
          &nbsp;·&nbsp;<a href="/privacy" className="underline">Privacy</a>
          &nbsp;·&nbsp;<a href="/status" className="underline">Status</a>
        </p>
      </div>
    </footer>
  );
}
